import { useRecoilValue } from "recoil"
import { styled } from "styled-components"
import { langSelector, langState } from "../../../state/langState"

const WayForward = () => {
	const currentLang = useRecoilValue(langState)
	const Text = useRecoilValue(langSelector)

	return(
		<Container>
			<Img currentLang={currentLang} src = {Text.wayForward.imgSrc} alt="text"/>
		</Container>
	)
}

export default WayForward


interface Props {
	currentLang:boolean;
}

const Container = styled.section`
  background:url(/imgs/about/background/thumbnail2.jpg) no-repeat center center/cover;
	height:1125px;
	display: flex;
	justify-content: center;
	align-items: center;
`


const Img = styled.img<Props>`
	${props => props.currentLang ?
		`
			width:350px;
			height:505px;
		`
		:
		`
			width:1146px;
			height:248px;
		`
	}
`